angular
  .module('contrast.services.attack', [])
  .factory(
    'AttackService',
    function (TimeService, AttackFactory, ATTACK_STATUS_LABEL) {
      'ngInject'

      return {
        calculateApps: function (attacks) {
          angular.forEach(attacks, function (attack) {
            attack.apps = []
            angular.forEach(attack.attacksApplication, function (attackApp) {
              attack.apps.push({
                id: attackApp.application.app_id,
                app_id: attackApp.application.app_id,
                name: attackApp.application.name,
                importance: attackApp.application.importance,
                status:
                  ATTACK_STATUS_LABEL[attackApp.application.attack_status],
                context_path: attackApp.application.context_path,
                primary: attackApp.application.primary,
                license_level: attackApp.application.license_level
              })
            })
          })

          return attacks
        },
        createRequest: function (scope) {
          var request = {}
          if (moment(scope.model.date.startDate).isValid()) {
            request.startDate = TimeService.getTimeInUserTimeZone(
              moment(scope.model.date.startDate).format('x')
            )
          }
          if (moment(scope.model.date.endDate).isValid()) {
            request.endDate = TimeService.getTimeInUserTimeZone(
              moment(scope.model.date.endDate).format('x')
            )
          }
          request.keyword = scope.searchKeywords()

          if (scope.model.eventUuid) {
            request.events = [scope.model.eventUuid]
          }

          request.quickFilter = scope.selectedQuickFilter.filterType

          request.tags = scope.selectedTags
          request.results = scope.selectedResults
          request.rules = scope.selectedRules
          request.applications = scope.selectedApplications
          request.servers = scope.selectedServers
          request.environments = scope.selectedEnvironments
          request.attackers = scope.selectedAttackers
          request.severities = scope.selectedSeverities

          request.attackUuid = scope.attackUuid

          return request
        },
        getUUIDLoadRequest: function (requestParams) {
          return AttackFactory.getAttacksUUIDs(requestParams)
        }
      }
    }
  )
